// extracted by mini-css-extract-plugin
module.exports = {"input":"index_input_2KeCq"};